import 'twin.macro';

import { navigate } from '@reach/router';
import IconDollar from 'assets/svg/icons/dollar.inline.svg';
import Button from 'components/Molecules/Button';
import SEO from 'components/SEO';
import FooterArticle from 'components/Templates/FooterArticle';
import ItemHeader from 'components/Templates/news/ItemHeader';
import { routes } from 'constants/routes';
import HeaderContext, { HEADER_TYPE } from 'providers/HeaderProvider';
import React, { useContext, useEffect } from 'react';

export default function factoring() {
	const { setHeader } = useContext(HeaderContext);

	useEffect(() => {
		setHeader({ type: HEADER_TYPE.ARTICLE, title: 'Akademia Smart Faktor' });
		return () => {
			setHeader({ type: HEADER_TYPE.DEFAULT, title: null });
		};
	}, []);

	return (
		<div>
			<SEO
				title='Faktoring w budownictwie, jak korzystać i kiedy się opłaca'
				keywords='ile kosztuje faktoring, faktoring w budownictwie, dla deweloperów, roboty budowlane, alternatywa dla kredytu, usługi wykonawcze, leasing pracowniczy, cena faktoringu'
				description='Dowiedź się jak skutecznie zastosować faktoring w firmie budowlanej, jak są koszty i dlaczego jest to lepsza alternatywa dla kredytu.'
				image={`${process.env.GATSBY_API_SEO_URL}/files/articles/construction/rozwoj_firmy.jpg`}
				alt='faktoring w budownictwie'
				contentType='article'
			/>

			<ItemHeader
				className='text-light bg-accent-3 p-24'
				footClassName='px-24 py-07 flex items-center text-light bg-accent-4'
				title='Faktoring, sposób na finansowanie dla firm'
				subtitle='Faktoring to szybki i wygodny sposób na uzyskanie finansowania. Dzięki jasnym kryteriom i prostym procedurom umożliwia poprawę płynności wtedy, kiedy jest ona najbardziej potrzebna.'
				footTitle='7 min. | Aktualności'
				industries={[
					{ node: { id: 1, name: 'Budownictwo i drogownictwo' }},
					{ node: { id: 2, name: 'Górnictwo i kopalnictwo' }},
					{ node: { id: 3, name: 'Hotele i restauracje' }},
					{ node: { id: 4, name: 'Transport i logistyka' }},
					{ node: { id: 5, name: 'Służba zdrowia i opieka socjalna' }},
					{ node: { id: 6, name: 'Media reklama PR' }},
					{ node: { id: 7, name: 'Informatyka i telekomunikacja' }},
					{ node: { id: 8, name: 'Handel hurtowy i detaliczny' }},
				]}
			/>

			<div className='font-lat text-13 text-grey-4 border-b border-dotted border-grey-C pb-15 mb-15'>
				<p className='font-bold px-20 mt-15 mb-05'>SPIS TREŚCI:</p>

				<nav id="menu">
					<ul className='ul-custom-rectangle'>
						<li><a href="#faktoring-informacje">Podstawowe informacje o faktoringu,</a></li>
						<li>
							<a href="#faktoring-alternatywa">Faktoring jako alternatywa dla kredytu,
								<ul className='ul-custom-circle'>
									<li><a href="#wymagania-bankowe">Wymagania bankowe,</a></li>
									<li><a href="#wymagania-faktoringowe">Wymagania faktoringowe,</a></li>
								</ul>
							</a>
						</li>
						<li><a href="#faktoring-wycena">Jak wycenić faktoring?</a></li>
						<li><a href="#faktoring-dostaw">Faktoring dostaw, usług wykonawczych, leasingu pracowników,</a></li>
						<li><a href="#procedura-finansowania">Procedura uzyskania finansowania,</a></li>
						<li><a href="#podsumowanie">Podsumowanie.</a></li>
					</ul>
				</nav>
			</div>

			<div id='article'>
				<div className='font-lat text-justify px-15'>
					<p className='relative text-14 text-left font-bold text-accent-3 mt-20'>
						<span id="faktoring-informacje" className='w-full h-10 absolute' style={{ top: '-9rem'}} />
						Podstawowe informacje o faktoringu
					</p>
					<p className='text-12 text-justify my-10'>
						Faktoring to usługa finansowania należności, której ryzyko jest oceniane przede wszystkim poprzez wiarygodność dłużnika.
						W praktyce oznacza to, że na <span>decyzję o finansowaniu</span> wpływa <span>bardziej rzetelność odbiorcy</span> towarów
						lub usług <span>aniżeli</span> finansowa wiarygodność <span>dostawcy</span> (faktoranta).
					</p>
					<p className='text-12 text-italic text-justify'>Przykład 1: Firma Jana Kowalskiego przechodzi przez trudny okres. Epidemia Covid spowodowała “zamrożenie” kilku kontraktów i konieczność redukcji personelu, w efekcie przedsiębiorstwo notuje straty.</p>
					<p className='text-12 text-italic text-justify'>Pojawia się jednak szansa, pan Jan wygrywa nowe zamówienie na dostawy do obiecującego klienta, firmy o dobrej reputacji płatniczej. Bank raczej nie udzieli kredytu firmieJana z powodu ujemnego rachunku wyników, tymczasem dla firmy faktoringowej to nie problem.</p>
					<p className='text-12 text-italic text-justify'>Każda faktura wystawiona na wiarygodnego klienta uruchamia niezwłocznie przelew środków i odblokowuje możliwość opłacenia bieżących zobowiązań. Firma Jana wychodzi na prostą.</p>
					<p className='text-12 text-justify my-10'>
						<span>Faktoring jest usługą skrócenia okresu płatności</span>, realizowaną poprzez wypłatę <span>zaliczki faktoringowej</span> opiewającej
						na 80-90% wartości faktury brutto. Dzięki temu przedsiębiorca zyskuje możliwość terminowej regulacji zobowiązań pracowniczych, skarbowych i handlowych.
					</p>

					<p className='relative text-14 text-left font-bold text-accent-3'>
						<span id="faktoring-alternatywa" className='w-full h-10 absolute' style={{ top: '-9rem'}} />
						Faktoring jako alternatywa kredytu
					</p>
					<p className='text-12 text-italic text-justify'>Wielokrotnie można usłyszeć, że <span>faktoring to alternatywa dla kredytu</span>, ale co to oznacza wpraktyce? Poniżej zestawiam kryteria bankowe i faktoringowe do samodzielnej oceny czytelnika.</p>

					<Button primary onClick={() => navigate(routes.PRODUCTS)} tw='bg-accent-3 my-nav mx-auto'>
						<IconDollar/><p style={{ margin: 0 }}>Sprawdź ofertę</p>
					</Button>

					<p className='relative text-14 text-left font-bold text-accent-3'>
						<span id="wymagania-bankowe" className='w-full h-10 absolute' style={{ top: '-9rem'}} />
						Wymagania bankowe
					</p>
					<p className='text-12'>
						<span>Banki</span> finansują firmy, które wykazują określony poziom rentowności i wiarygodności kredytowej.
						Takie obowiązki nakłada na nie prawo i praktyka procedur bankowych. <span>W sytuacjach wątpliwych uciekają od ryzyka</span> żądając “twardego zabezpieczenia”, czyli wpisu hipotecznego na nieruchomości.
					</p>
					<p className='text-12'>Wymagania bankowe w skrócie:</p>
					<ul className='list-disc text-12 mb-15'>
						<li><span>rentowność</span> (zyskowność) na określonym, bezpiecznym poziomie,</li>
						<li>pozytywna <span>historia</span>, czyli wzrost sprzedaży, utrzymanie rentowności, kontrola kosztów,</li>
						<li>określona <span>kapitalizacja</span>, czyli właściwa struktura bilansowa firmy, kapitały własne w określonej proporcji do ogółu zobowiązań, zobowiązania bieżące nie większe aniżeli aktywa obrotowe itp.,</li>
						<li>bezpieczna dla banku <span>forma prawna działalności</span>, młode firmy i spółki z o.o. często są “z automatu” na czarnej liście,</li>
					</ul>
				</div>

				<img src='../../files/articles/construction/spotkanie_firmowe.jpg' alt='spotkanie firmowe i uścisk dłoni' width='100%' />

				<div className='font-lat text-12 px-15'>
					<p className='relative text-14 text-left font-bold text-accent-3'>
						<span id="wymagania-faktoringowe" className='w-full h-10 absolute' style={{ top: '-9rem'}} />
						Wymagania faktoringowe
					</p>
					<p>
						Optyka finansowania poprzez <span>faktoring skupia się</span> nie na wiarygodności kredytowej przedsiębiorstwa,
						ale <span>na fakcie wykonania usługi lub dostawy towaru</span>, z którego wynika <span>należność handlowa</span> do rozliczenia w przyszłości.
					</p>
					<p>
						Dla <span>faktoringu kluczowa jest wiarygodność dłużnika</span> oraz <span>pewność wykonanej dostawy</span>.
						Objęcie usługą finansowania należności od wielu dłużników poprawia ich “statystyczną jakość”, ponieważ ryzyko że wszyscy naraz zawiodą
						jest o wiele niższe. Stąd też faktoring będzie naturalnie dążył do <span>oparcia współpracy na więcej aniżeli jednym dłużniku.</span>
					</p>
					<p>
						<span>Wiarygodność dłużnika</span> jest oceniana na podstawie <span>analizy publicznie dostępnych danych</span>, w tym
						jego wyników finansowych i terminowości w spłacie zobowiązań.
					</p>
					<p>Wymagania faktoringowe sprowadzają się analizy dokumentów:</p>
					<ul className='list-disc text-12 mb-15'>
						<li><span>umowy</span> (zyskowność) na określonym, bezpiecznym poziomie,</li>
						<li><span>faktur</span>, określających wartość należności i termin jej rozliczenia,</li>
						<li>pisemnego <span>potwierdzenia dostawy</span>, towaru lub wykonania usługi,</li>
						<li>potwierdzenia <span>zawiadomienia o cesji</span>.</li>
					</ul>
				</div>

				<img src='../../files/articles/construction/rozwoj_firmy.jpg' alt='kostki trzymane w dłoniach obrazujące wzrost i rozwój firmy' width='100%' />

				<div className='font-lat text-12 text-justify px-15'>
					<p className='relative text-14 text-left font-bold text-accent-3'>
						<span id="faktoring-wycena" className='w-full h-10 absolute' style={{ top: '-9rem'}} />
						Jak wycenić faktoring?
					</p>
					<p>
						<span>Najważniejszym kryterium</span> oceny atrakcyjności danego finansowania <span>jest rzeczywista dostępność usługi</span>. Faktorzy
						poszukują określonego typu wierzytelności, biorąc pod uwagęrodzaj ryzyka, wielkość zaangażowania, cykl rotacji należności i inne warunki. Z tego też względu te same należności mogą być przedmiotem usługi finansowania u jednego faktora podczas spotkają się z odmową u innego.
					</p>
					<p>
						<span>Drugim czynnikiem</span> są warunki <span>cenowe</span>. W skrócie mamy do czynienia z dwiema pozycjami, opłatami administracyjnymi i kosztem zaangażowanego kapitału. Często usługi mikrofaktoringowe “zliczają” obie te pozycje do jednej raty. Odwrotnie jest przy większych finansowaniach gdzie poszczególne rodzaje kosztów są wymienione bardzo szczegółowo.
					</p>
					<p>
						<span>Koszt</span> finansowania faktoringiem u dobrego faktora <span>jest porównywalny</span> z <span>kredytem</span> bankowym. Wyliczenie dokładnych cen jest wynikiem kalkulacji:
					</p>
					<ul className='list-disc text-12'>
						<li>wartości pojedynczych faktur,</li>
						<li>ich ilości,</li>
						<li>terminu spłaty.</li>
					</ul>
					<p>Ważnym czynnikiem kosztowym są też <span>nierzetelni płatnicy</span>. W przypadku nieterminowego rozliczania się dłużnika, ewentualnych wezwań do zapłaty lub dochodzenia wierzytelności na drodze windykacji trzeba liczyć się z kosztami. W takim wypadku lepiej poszukać solidniejszych klientów na rynku.</p>

					<p className='relative text-14 text-left font-bold text-accent-3'>
						<span id="faktoring-dostaw" className='w-full h-10 absolute' style={{ top: '-9rem'}} />
						Faktoring dostaw, usług wykonawczych i leasingu pracowników
					</p>
					<p>Bardzo dobrym przykładem wykorzystania faktoringu są <span>usługi budowlane</span>. Niewiele banków jest skłonnych finansować wykonawców budów i ich dostawców z uwagi na ryzyko zleceniodawcy oraz złą reputację branży. Tymczasem nie jest tak źle jakby się mogło wydawać.</p>
					<p>Usługi budowlane, usługi dostawcze, wykonawcze lub usługi leasingu pracowniczego niewiele się różnią od innych i podlegają podobnym kryteriom finansowania poprzez faktoring.</p>
					<p>Niezbędne są:</p>
					<ul className='list-disc text-12'>
						<li>umowa, kontrakt, pisemne zlecenie wykonania określonych prac, dostawy usług lub pracowników jako podstawa,</li>
						<li>dokumentacja wykonania zlecenia, dostawy, świadczenia usługi ciągłej potwierdzona podpisem osoby reprezentującej odbiorcę,</li>
						<li>faktura ze wskazanym numerem konta faktora oraz potwierdzenie jej przyjęcia podpisem odbiorcy,</li>
						<li>potwierdzenie zawiadomienia o cesji (przelewie) wierzytelności ze strony odbiorcy.</li>
					</ul>
					<p className='text-italic text-justify'>Przykład 2: Firma Krzysztofa Nowaka sprowadza pracowników zza wschodniej granicy i wynajmuje ich do pracy na budowach w Polsce. Pomimo zamieszania jakie początkowo wywołała epidemiarynek w dalszym ciągu poszukuje siły roboczej. Firma Krzysztofa zwiększa sprzedaż, lecz 30 dniowe terminy płatności odczuwa coraz boleśniej.</p>
					<p className='text-italic text-justify'>Pracownicy oczekują tygodniówek, pojawiają się inne koszty i możliwości finansowe Krzysztofa są coraz bardziej napięte, pomimo rosnących zysków. Jego niewielka firma nie spełnia kryteriów bankowych, a finansowanie pożyczkami ma swoje ograniczenia. Skutek jest taki, że Krzysztof nie może realizować następnych zleceń, dopóki nie spłyną mu pieniądze z wystawionych już faktur.</p>
					<p className='text-italic text-justify'>Krzysztof oddaje faktury do finansowania i już w 24h ma opłacone wszystkie swoje zobowiązania. Dopina kolejny kontrakt mając pewność, że starczy mu pieniędzy na bieżące rozliczenia. Firma uzyskała tak bardzo potrzebną jej płynność.</p>
				</div>

				<img src='../../files/pic3.jpg' alt='spotkanie firmowe z teczką' width='100%' />

				<div className='font-lat text-12 text-justify px-15 border-b border-grey-C'>
					<p className='relative text-14 text-left font-bold text-accent-3'>
						<span id="procedura-finansowania" className='w-full h-10 absolute' style={{ top: '-9rem'}} />
						Procedury uzyskania finansowania
					</p>
					<p>Faktoring cechuje zazwyczaj płaska struktura korporacyjna i jasne kryteria oceny. W przeciwieństwie do banków, które prowadzą złożone analizy w wyspecjalizowanych departamentach faktoring działa o wiele bardziej przewidywalny i konkretny sposób. Przekłada się to także na zakres niezbędnych dokumentów.</p>
					<p>
						Wstępną akceptację wielkości finansowania możemy uzyskać po przesłaniu szacunkowych wartości faktur, terminów ich płatności i numeru NIP klienta,
						article		a jeszcze prościej <span>po przesłaniu samej faktury</span> na której będą te wszystkie informacje. Kiedy dostaniemy pozytywną informację co do limitu, wtedy możemy zastanowić się nad kosztami.
					</p>
					<p>Faktoring można uzyskać w tydzień, od momentu decyzji o finansowaniu do uzyskania środków na rachunku. Uruchomienie finansowania jest dostępne po podpisaniu i dostarczeniu oryginału umowy. Faktury, ich potwierdzenia dostaw i zawiadomienie o cesji mogą być dostarczone elektronicznie.</p>

					<p className='relative text-14 text-left font-bold text-accent-3'>
						<span id="podsumowanie" className='w-full h-10 absolute' style={{ top: '-9rem'}} />
						Podsumowanie
					</p>
					<p>Płynność finansowa jest warunkiem istnienia i rozwoju każdej firmy, a terminowość regulowania zobowiązań najlepszym wskaźnikiem jej jakości. Faktoring daje wsparcie właśnie w tych, kluczowych aspektach działalności gospodarczej. Co również istotne, sposób alokacji ryzyka (przeniesienie na dłużników) pozwala na finansowanie wtedy, kiedy firma miałyby poważne trudności z uzyskaniem lub odnowieniem kredytu bankowego. </p>
				</div>
			</div>

			<FooterArticle />

			{/*<NewsItem*/}
			{/*	path={`${routes.NEWS}/:path`}*/}
			{/*	title='dawdawdawdaw'*/}
			{/*	description='dawdawd'*/}
			{/*/>*/}
		</div>
	);
}
